export default function IconA() {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.666 18.3335L39.1422 43.3335L68.3327 18.3335" stroke="#FF8A00" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="10" y="16.6665" width="60" height="46.6667" rx="3.33333" stroke="#FF8A00" strokeWidth="4" />
        </svg>
    );
}
